import { useState } from 'react';

import { Button, Icon, TextField, Typography } from '@/ui';

import type { User } from '@/types';

import { useUpdateUserMutation } from '@/store/api/userApi';

export const renderStatusCellContent = (user: User) => (
  <Typography color="text.secondary" variant="caption">
    {user.memberStatus ?? '—'}
  </Typography>
);

export const getSeatTypeLabel = (user: User): string =>
  user.profile?.seatType === 'executive' ? 'Executive' : 'Leadership';

export const renderGrowthPlanIcon = (hasStarted: boolean) =>
  hasStarted ? (
    <Icon color="success">check</Icon>
  ) : (
    <Icon color="warning">close</Icon>
  );

interface AdminNoteCellProps {
  initialAdminNote?: string;
  userId: string;
}

export const AdminNoteCell = ({
  initialAdminNote,
  userId,
}: AdminNoteCellProps) => {
  const [adminNote, setAdminNote] = useState(initialAdminNote ?? '');
  const [isSaving, setIsSaving] = useState(false);
  const [showSaved, setShowSaved] = useState(false);
  const [updateUser] = useUpdateUserMutation();

  const handleSaveNote = async () => {
    try {
      setIsSaving(true);
      await updateUser({ id: userId, user: { adminNote } }).unwrap();
      setIsSaving(false);
      setShowSaved(true);
      setTimeout(() => setShowSaved(false), 1500);
    } catch (error) {
      console.error('Error saving admin note:', error);
      setIsSaving(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <TextField
        placeholder="Admin note"
        rows={2}
        size="small"
        value={adminNote}
        multiline
        onChange={(event) => setAdminNote(event.target.value)}
      />
      <Button
        disabled={isSaving}
        size="small"
        variant="contained"
        onClick={handleSaveNote}
      >
        Save
      </Button>
      <Typography
        className="text-green-600 transition-opacity duration-700"
        style={{ opacity: showSaved ? 1 : 0 }}
        variant="caption"
      >
        Saved!
      </Typography>
    </div>
  );
};
